export type WindowSizeGroup = 'xs' | 'sm' | 'md' | 'lg';
export type BrowserName = 'Safari' | 'Chrome' | 'Edge' | 'Firefox' | 'IE' | 'Opera';
export const SMALL_SCREEN_SIZES: WindowSizeGroup[] = ['xs', 'sm'];

// Screen size breakpoints in pixels based on width
export const SCREEN_SIZE_LG_MIN = 992;
export const SCREEN_SIZE_MD_MAX = SCREEN_SIZE_LG_MIN - 1; // 991
export const SCREEN_SIZE_MD_MIN = 768;
export const SCREEN_SIZE_SM_MAX = SCREEN_SIZE_MD_MIN - 1; // 767
export const SCREEN_SIZE_SM_MIN = 480;
export const SCREEN_SIZE_XS_MAX = SCREEN_SIZE_SM_MIN - 1; // 479
export const SCREEN_SIZE_XS_MIN = 0;

// Screen height breakpoints in pixels based on height
export const SCREEN_HEIGHT_LG_MIN = 800;
export const SCREEN_HEIGHT_MD_MAX = SCREEN_HEIGHT_LG_MIN - 1; // 799
export const SCREEN_HEIGHT_MD_MIN = 600;
export const SCREEN_HEIGHT_SM_MAX = SCREEN_HEIGHT_MD_MIN - 1; // 599
export const SCREEN_HEIGHT_SM_MIN = 480;
export const SCREEN_HEIGHT_XS_MAX = SCREEN_HEIGHT_SM_MIN - 1; // 479
export const SCREEN_HEIGHT_XS_MIN = 0;

export class WindowSizeInfo {
  public readonly sizeGroup: WindowSizeGroup;
  public readonly sizeGroupHeight: WindowSizeGroup;
  public readonly isSmallScreen: boolean;
  public readonly isSmallScreenHeight: boolean;

  constructor(
    public readonly windowWidth: number,
    public readonly windowHeight: number,
    public readonly screenWidth: number,
    public readonly screenHeight: number,
  ) {
    // Determine the size group based on the window width
    if (windowWidth <= SCREEN_SIZE_XS_MAX) {
      this.sizeGroup = 'xs';
    } else if (windowWidth <= SCREEN_SIZE_SM_MAX) {
      this.sizeGroup = 'sm';
    } else if (windowWidth <= SCREEN_SIZE_MD_MAX) {
      this.sizeGroup = 'md';
    } else {
      this.sizeGroup = 'lg';
    }

    if (screenHeight <= SCREEN_HEIGHT_SM_MAX) {
      this.sizeGroupHeight = 'sm';
    } else if (screenHeight <= SCREEN_HEIGHT_MD_MAX) {
      this.sizeGroupHeight = 'md';
    } else {
      this.sizeGroupHeight = 'lg';
    }

    // Determine if the screen is small based on the size group
    this.isSmallScreen = SMALL_SCREEN_SIZES.includes(this.sizeGroup);
    this.isSmallScreenHeight = SMALL_SCREEN_SIZES.includes(this.sizeGroupHeight);
  }
}
